import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { IconChevronDown, Anchor, TextButton, StyledIcon, token, List, ListItem } from "@zillow/constellation";
import { yieldCallback } from "@zillow/yield-callback";
import PropTypes from "prop-types";
import styled from "styled-components";
const SEOFooterSubmenuHeader = styled(TextButton).withConfig({
  displayName: "SEOFooterSubmenu__SEOFooterSubmenuHeader",
  componentId: "sc-kyc3ft-0"
})(["padding:12px 16px;", "{color:", ";width:16px;height:16px;margin-left:", ";}"], StyledIcon, token("colors.brand"), token("spacing.md"));
const SEOFooterSubmenuList = styled(List).withConfig({
  displayName: "SEOFooterSubmenu__SEOFooterSubmenuList",
  componentId: "sc-kyc3ft-1"
})(["margin-top:0;margin-bottom:0;"]);
const SEOFooterSubmenuListItem = styled(ListItem).withConfig({
  displayName: "SEOFooterSubmenu__SEOFooterSubmenuListItem",
  componentId: "sc-kyc3ft-2"
})(["margin-top:0;margin-bottom:0;"]);
const SEOFooterSubmenu = ({
  label,
  links
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(SEOFooterSubmenuHeader, { buttonType: "secondary", fontType: "bodyHeading", icon: /* @__PURE__ */ jsx(IconChevronDown, { size: "xs" }), iconPosition: "end", onClick: yieldCallback(() => setIsOpen(!isOpen)), children: label }),
    isOpen && /* @__PURE__ */ jsx(SEOFooterSubmenuList, { appearance: "none", children: links.map((link) => /* @__PURE__ */ jsx(SEOFooterSubmenuListItem, { children: /* @__PURE__ */ jsx(Anchor, { href: link.src, target: link.target, children: link.label }) }, link == null ? void 0 : link.label)) })
  ] });
};
SEOFooterSubmenu.propTypes = {
  label: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    src: PropTypes.string,
    target: PropTypes.string
  })).isRequired
};
export {
  SEOFooterSubmenuHeader,
  SEOFooterSubmenuList,
  SEOFooterSubmenuListItem,
  SEOFooterSubmenu as default
};
